import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./validations.css"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
// import ValidateCats from '../../../../components/common/ValidateCats';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
// import { toast } from 'react-toastify';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Assignments from './Assignments';
import TaskKnowledge from './TaskKnowledge';
import TaskHistory from './TaskHistory';
import CaseDetails from '../CaseDetails/CaseDetails';
import OnboardingDiscussTab from './OnboardingDiscussTab';
function I94Validation() {

    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const onboardslug = parts_location[2] || null;
    const userid = parts_location[3] || null;
    const taskData = parts_location[4] || null;
    const [expanded, setExpanded] = useState(true);
    const UserRoles = localStorage.getItem('role');
    const [value, setValue] = useState(dayjs(null));
    const navigate = useNavigate();
    const [showform, setShowform] = useState(true);
    const [showedit, setShowedit] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState("");
    const [jobseekerName, setJobseekername] = useState("");
    const [jobseekerid, setJobseekerid] = useState("");
    const [caseids, setcaseid] = useState("");
    const [i94copy, seti94copy] = useState("");
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showSubmits, setShowSubmits] = useState(false);
    const [showCase, setShowCase] = useState(false);
    const [CaseAlldetail, setCaseAllDetail] = useState([]);
    const [showPaaI94, setShowPassI94] = useState(false);
    const [opendata2, setOpendata2] = useState(false);
    const [showCurrcase, setCaseIdscurrent] = useState('');
    useEffect(() => {
        if(taskData){
            const fetchData = async () => {
                try {
                    const response = await apiService.getRequest(`task/details/${taskData}`);
                    if (response.success && response.success === true) {
                        setCaseIdscurrent(response.data.case_og_id);
                    }
                } catch (error) {
                    console.error("Error fetching onboarding data:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchData();
        }
    }, [taskData, navigate]);
    const fetchData = useCallback(async () => {
        if(onboardslug && userid && showCurrcase){
            try {
            const response = await apiService.getRequest(`/onboarding/${onboardslug}/${userid}/${showCurrcase}`);
            if (response.success && response.success === true) {
                if(response && response.data.jobseeker_validation_type === "i94_validation"){
                    setShowPassI94(true);
                }else{
                    setShowPassI94(false);
                }
                setCaseAllDetail(response.data.case);
                setShowSubmits(response.can_submit);
                setShowCase(response.data.can_see_case);
                seti94copy(response.data.i94_copy);
                setJobseekername(response.data.jobseeker.name);
                setJobseekerid(response.data.jobseeker.id);
                setcaseid(response?.data);
                setStatus(response.data.status_string);
                const refetchedData = response.data.form_data;
                setFileNames({
                    i94_document: refetchedData.i94_document || response?.data?.i94_copy || null,
                    passport_document: refetchedData.passport_document || response?.data?.passportPath || null,
                })
                setFormData({
                    valid_i94_doc: refetchedData.valid_i94_doc || "",
                    passport_number: refetchedData.passport_number || "",
                    jobseeker_type: refetchedData.jobseeker_type || "",
                    first_name:refetchedData.first_name || "",
                    last_name: refetchedData.last_name || "",
                    dob: refetchedData.dob || "",
                    i94_document: refetchedData.i94_document || response?.data?.i94_copy || null,
                    passport_document: refetchedData.passport_document || response?.data?.passportPath || null,
                });
                if (refetchedData.dob) {
                const parsedDob = dayjs(refetchedData.dob, 'YYYY-MM-DD');
                if (parsedDob.isValid()) {
                    setValue(parsedDob); 
                }
            }
                if (
                    ((response && response.data.form_data && Object.keys(response.data.form_data).length === 0) ||
                    (response && response.data.form_data && (!response.data.form_data.passport_document || Object.keys(response.data.form_data.passport_document).length === 0) && (!response.data.form_data.valid_i94_doc || Object.keys(response.data.form_data.valid_i94_doc).length === 0))
                ) 
                    && (response && response.data.status_string === "in-progress")
                ){
                setShowform(true);
                if(response && response.data.jobseeker_validation_type !== "i94_validation" ){
                    setOpendata(true);
                    setOpendata2(true);
                }else{
                    setOpendata2(false);
                    setOpendata(false);
                }
                }else{
                if(response && response.data.jobseeker_validation_type !== "i94_validation" ){
                    setOpendata(true);
                    setOpendata2(true);
                }else if(response && response.data.form_data && response.data.form_data.valid_i94_doc === "Yes"){
                    setOpendata(true);
                }else{
                    setOpendata2(false);
                    setOpendata(false);
                }
                setShowform(false);
                }
            }else{
                if(response.error_code === "E_PERMISSION_DENIED"){
                    toast.error(response.message || "Permission denied!");
                    navigate("/dashboard");
                }else if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            } catch (error) {
            console.error("Error fetching onboarding data:", error);
            } finally {
            setLoading(false);
            }
        }
    }, [onboardslug, userid, showCurrcase, navigate]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    useEffect(() => {
        if(userid && showCurrcase){
            const fetchCurrentData = async () => {
                try {
                const response = await apiService.getRequest(`/current-onboarding/${userid}/${showCurrcase}`);
                if (response.success && response.success === true) {
                    if(response && Array.isArray(response.onboarding) && response.onboarding.includes(onboardslug) && response.status && response.status["i94-validation"] === "in-progress"){
                        setShowedit(true);
                    }else{
                        setShowedit(false)
                    }
                }
                } catch (error) {
                console.error("Error fetching onboarding data:", error);
                } finally {
                setLoading(false);
                }
            };
            fetchCurrentData();
        }
    }, [ userid,onboardslug, showCurrcase]);

    const [fileNames, setFileNames] = useState({
        i94_document: "",
        passport_document: "",
    });
    const [formData, setFormData] = useState({
        valid_i94_doc: "",
        passport_number: "",
        jobseeker_type: "",
        first_name:"",
        last_name: "",
        dob: "",
        i94_document: null,
        passport_document: null,
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [opendata, setOpendata] = useState(false);
       // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));

        // Validate valid_i94_doc
        if(!opendata2 && showPaaI94){
            if (name === 'valid_i94_doc') {
                if (value === 'Yes') {
                    setOpendata(true);
                } else {
                    setOpendata(false);
                    // setFormData(prevData => ({
                    //     ...prevData,
                    //     passport_number: "",
                    //     first_name:"",
                    //     last_name: "",
                    //     dob: "",
                    //     i94_document: null,
                    // }));
                    // setValue(dayjs(null));
                    // setFileNames({
                    //     i94_document: "",
                    // });
                }
            }
        }
    };
    const handlePassportBlur = async () => {
        try {
        const response = await apiService.postRequest(
            "/check-passport-status",
            { passport_number: formData.passport_number, user_id: userid }
        );
    
        if (response && response.success === true) {
            if (response.passport_number && response.passport_number.length !== 0) {
                setFormData({ ...formData, jobseeker_type: response.passport_number });
            }else{
                setFormData({ ...formData, jobseeker_type: '' });
            }
        }else{
            setFormData({ ...formData, jobseeker_type: '' });
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
        } catch (error) {
        console.error("Error checking passport status:", error);
        }
    };
    
  // Handle file change
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
        const file = files[0]; // Get the selected file

        // Update the formData state with the new file
        setFormData((prevData) => ({
            ...prevData,
            [name]: file, // Store the file object for submission
        }));
        
        // Update the fileNames state to show the file name
        setFileNames((prevNames) => ({
            ...prevNames,
            [name]: file.name, // Store the file name for display
        }));
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name]; // Remove the error for the file field
            return updatedErrors;
        });
    }
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};
    if(!opendata2){
        if (!formData.valid_i94_doc) newErrors.valid_i94_doc = "Please select Yes or No.";
    }
    if (opendata) {
        if (!formData.jobseeker_type) newErrors.jobseeker_type = "Jobseeker type is required.";
        if (!formData.passport_number) newErrors.passport_number = "Passport number is required.";
        if (!formData.first_name) newErrors.first_name = "First name is required.";
        if (!formData.last_name) newErrors.last_name = "Last name is required.";
        if (!formData.dob) newErrors.dob = "Date of birth is required.";
    if(!opendata2 && showPaaI94){
        if (!formData.i94_document) newErrors.i94_document = "Please upload the I-94 document.";
    }else{
        if (!formData.passport_document) newErrors.passport_document = "Please upload the passport document.";
    }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleDateChange = (newValue) => {
    if (newValue) {
        setValue(newValue);
        setFormData({ ...formData, dob: newValue.format('YYYY-MM-DD') });

        // Clear the error for dob if a valid date is entered
        if (errors.dob) {
            setErrors({ ...errors, dob: '' });
        }
    } else {
        setValue(null);
        setFormData({ ...formData, dob: '' }); // Clear the value if null
    }
};
    const [submitloader,setSubmitloader] = useState(false);
  // Handle form submission
  const handleSubmit = async (e, triggerStatus) => {
    e.preventDefault();
    if (!validateForm()) {
        setErrorMessage('Please fix the errors before proceeding.');
        return;
    }
    setSubmitloader(true);
    try {
        const formDataToSend = new FormData();
        if (formData.valid_i94_doc === "No") {
            formDataToSend.append('valid_i94_doc', formData.valid_i94_doc);
        } else {
            Object.keys(formData).forEach((key) => {
                const value = formData[key];
                
                // Skip if null or if it's a string file field
                const isStringFileField = typeof value === 'string' && ['i94_document', 'passport_document'].includes(key);
                
                if (value !== null && !isStringFileField) {
                    formDataToSend.append(key, value);
                }
            });
        }

        if (!opendata2 && showPaaI94) {
            formDataToSend.delete('passport_document');
        } else {
            formDataToSend.delete('valid_i94_doc');
            formDataToSend.delete('i94_document');
        }
        // Make the API request
        const response = await apiService.postRequest(`onboarding/${onboardslug}/${userid}/submit`, formDataToSend);

        // Check response for success
        if (response && response.success === true) {
            setErrors({});
            setErrorMessage('');
            setEditMode(false);
            setShowform(false);
            fetchData();
            if(response.success && response.status === "rejected"){
                window.location.reload();
            }else{
                if (triggerStatus) {
                    handleslectChange();
                }
            }
            
        } else {
            setErrorMessage(response.message || "Failed. Please try again");
            if (response.errors) {
              setErrors(response.errors);
            }
            if (response.notify_toast) {
                toast(response.message);
            }
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
    } catch (error) {
        console.log(error,'Failed. Please try again.');
    } finally {
        setSubmitloader(false); // Stop loader
    }
  };
  

  const [selectedStatus, setSelectedStatus] = useState("");
  const [show, setShow] = useState(false);

  const handleslectChange = () => {
    setSelectedStatus("completed");
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const [statuserror,setStatuserror] = useState("");
    const [submitloader2,setSubmitloader2] = useState(false);
    const confirmStatusChange = async () => {
      setShow(false); // Close the modal
      setStatus(selectedStatus); // Update the status locally
      setSubmitloader2(true);
      try {
        const response = await apiService.postRequest(
          `/task/update/status/${taskData}`,
          {
            status: selectedStatus,
          }
        );
        if (response && response.success === true) {
          toast(response.message || "Status updated successfully!");
          window.location.reload();
          setStatuserror("");
        }else{
            setStatuserror(response.message);
            setStatus("in-progress");
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
      } catch (error) {
        console.error("Error updating status:", error);
        toast.error("Failed to update status. Please try again.");
      }finally {
          setSubmitloader2(false); // Stop loader
      }
    };


    const [errorsCase, setErrorsCase] = useState({});
    const [errorsCaseMessage, setErrorMessageCase] = useState("");
    const [selectedCaseStatus, setSelectedCaseStatus] = useState("");
    const [showCasepop, setShowCasepop] = useState(false);
    const [loadingCase, setSubmitloaderCase] = useState(false);
    const [caseActionform, setCaseActionForm] = useState({
        status: "",
        justification: "",
    })

    const handleselectCase = (statussend) => {
        setSelectedCaseStatus(statussend);
        setShowCasepop(true);
        setCaseActionForm((prevData) => ({
            ...prevData,
            status: statussend,
        }));
    };
    const handleCloseCase = () => setShowCasepop(false);

    const handleInputCasedata = (e) => {
        const { name, value } = e.target;

        const newValue = name === "to_onboarding_id" ? Number(value) : value;

        setCaseActionForm((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));

        setErrorsCase((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const validateFormCase = () => {
        const newErrors = {};
        if (!caseActionform.justification) newErrors.justification = "Justification is required.";
        if (caseActionform.justification && caseActionform.justification.length < 3) {
            newErrors.justification = "justification must be at least 3 characters long.";
        }else if (caseActionform.justification && caseActionform.justification.length > 4000) {
            newErrors.justification = 'justification must be less than 4000 characters long.';
        }
        setErrorsCase(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCaseStatus = async (e) => {
        e.preventDefault();
        if (!validateFormCase()) {
            setErrorMessageCase('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloaderCase(true);
        try {
            const response = await apiService.postRequest(`/task-cases/${CaseAlldetail.id}/status`, caseActionform);
            
            if (response && response.success === true) {
                fetchData();
                window.location.reload();
                setErrorMessageCase("");
                setShowCasepop(false);
                setCaseActionForm({
                    status: "",
                    justification: "",
                })
            } else {
                if (response.errors) {
                    setErrorsCase(response.errors);
                }
                toast(response.message || "Somthing went wrong!")
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log(error,'Failed. Please try again.');
        } finally {
            setActiveTab("overview");
            setActiveTabCase("task");
            setSubmitloaderCase(false); // Stop loader
        }
    };

  return (
    <div className='container-fluid px-0' >
        <div className='content_container_validate' style={{ flexGrow: 1 }}>
            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${caseids?.case?.case_link}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.case?.case_formatted_id}
                    </b>
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.task?.task_format_id} - ${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.task?.task_format_id}
                    </b>
                </span>
            </Grid>
            {UserRoles && UserRoles !== "job_seeker" ?<>
            {loading ? 
                <div className='d-flex justify-content-center w-100'>
                    <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :
                <Grid size={{sm:12}} container className="main_jobseeker justify-content-between">
                    <Grid size={{ lg: expanded ? 7.6 : 11.5, md: expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container className={`pe-4 tab_controllers ${ expanded && "control_splits"} align-items-start align-content-start flex-row-reverse justify-content-between`}>
                        <Grid container className="case_control_btn" justifyContent="flex-end">
                            {showCase && activeTabCase === "case" && <>
                            {CaseAlldetail?.status !== "suspend" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "hold" ?
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("hold")}>Hold</button>:
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("resume")}>Resume</button>
                                }
                            </>}
                            {CaseAlldetail?.status !== "hold" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "suspend" ?
                                <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("suspend")}>Suspend</button>:
                                ""
                                }
                            </>}
                            </>}
                        </Grid>
                        <Tabs
                            activeKey={activeTabCase}
                            onSelect={(key) => setActiveTabCase(key)}
                            defaultActiveKey="task"
                            id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                        >
                            <Tab eventKey="task" title="Task">
                                <Grid size={{sm:12}} container alignItems="center">
                                    <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                                        <Grid container flexDirection="column">
                                            <h3>{showPaaI94 ? "I94 Validation" : "Passport Validation"} <small className='small_headingstatuses'>{status&&<>{status === "completed" ? "Completed":status === "rejected"? "Rejected":"In Progress"}</>}</small></h3>
                                            {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) ? 
                                                <Link className='seekerondetail' to={`/user/jobseeker-details/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>:
                                                <Link className='seekerondetail' to={`/user/jobseeker-profile/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                        <Tabs
                                            activeKey={activeTab}
                                            onSelect={(key) => setActiveTab(key)}
                                            defaultActiveKey="overview"
                                            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                            >
                                            <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                {(showform && showform === true) || (editMode && editMode === true) ? <>
                                                    {!opendata2 &&
                                                    <Grid size={{xs:12}} container justifyContent="flex-start" className="mt-4">
                                                        <div className='d-flex align-items-start note_bgyesno w-100'>
                                                            <b>Note:</b>
                                                            <span className='d-flex flex-column'>
                                                                <small>“If you says yes, you are granting approval for Jobseeker to proceed further.”</small>
                                                                <small>“If you says No, you are declining permission for Jobseeker to continue.”</small>
                                                            </span>
                                                        </div>
                                                    </Grid>}
                                                    <form className='w-100'>
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                            {!opendata2 &&
                                                            <Grid size={{sm:12}} container className="my-3" flexDirection="column">
                                                                <span>Did Jobseeker Submit a valid I94 document in the application ? <small>*</small><a className='view_fileshows' href={`${i94copy}`} target="_blank" rel="noopener noreferrer">View</a></span>
                                                                <div className='d-flex align-items-center main_radioregister'>
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="radio" 
                                                                        name="valid_i94_doc"
                                                                        value="Yes"
                                                                        checked={formData.valid_i94_doc  === "Yes"} 
                                                                        onChange={handleInputChange} 
                                                                    />Yes
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="radio" 
                                                                        name="valid_i94_doc"
                                                                        value="No"
                                                                        checked={formData.valid_i94_doc  === "No"} 
                                                                        onChange={handleInputChange} 
                                                                    />No
                                                                </div>
                                                                {errors.valid_i94_doc && <p style={{color:"Red"}}>{errors.valid_i94_doc}</p>}
                                                            </Grid>
                                                            }
                                                            {opendata && <>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Passport Number of Jobseeker<small>*</small></span>
                                                                <input
                                                                    type="text"
                                                                    disabled={!showSubmits}
                                                                    name="passport_number"
                                                                    value={formData.passport_number}
                                                                    onChange={handleInputChange} 
                                                                    onBlur={handlePassportBlur}
                                                                    maxLength={9}
                                                                    minLength={8}
                                                                    // onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                                />
                                                                {errors.passport_number && <p style={{color:"Red"}}>{errors.passport_number}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Jobseeker type<small>*</small></span>
                                                                <select name="jobseeker_type" 
                                                                value={formData.jobseeker_type}
                                                                onChange={handleInputChange} 
                                                                disabled={true}
                                                                >
                                                                    <option value="">Select Type</option>
                                                                    <option value="Existing">Existing</option>
                                                                    <option value="New">New</option>
                                                                </select>
                                                                {errors.jobseeker_type && <p style={{color:"Red"}}>{errors.jobseeker_type}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>First name of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"}<small>*</small></span>
                                                                <input
                                                                    disabled={!showSubmits}
                                                                    type="text"
                                                                    name="first_name"
                                                                    value={formData.first_name}
                                                                    onChange={handleInputChange} 
                                                                    onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                                />
                                                                {errors.first_name && <p style={{color:"Red"}}>{errors.first_name}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Last name of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"}<small>*</small></span>
                                                                <input
                                                                    disabled={!showSubmits}
                                                                    type="text"
                                                                    name="last_name"
                                                                    value={formData.last_name}
                                                                    onChange={handleInputChange} 
                                                                    onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                                />
                                                                {errors.last_name && <p style={{color:"Red"}}>{errors.last_name}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Date of Birth of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"} <small>*</small></span>
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <DatePicker
                                                                            disabled={!showSubmits}
                                                                            className="date_pickermux"
                                                                            value={value}
                                                                            onChange={handleDateChange}
                                                                            maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
                                                                            renderInput={(params) => <input {...params} />}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    {errors.dob && <p style={{color:"Red"}}>{errors.dob}</p>}
                                                            </Grid>
                                                            {!opendata2 ?
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container alignItems="flex-end" flexDirection="column">
                                                                <span>Upload the latest I-94 of the Jobseeker<small>*</small></span>
                                                                <div className="fileUploadInput">
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="file"
                                                                        name="i94_document"
                                                                        id="i94_document"
                                                                        onChange={handleFileChange}
                                                                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                                                                        style={{ display: 'none' }} // Hide the actual file input
                                                                    />
                                                                    <label htmlFor="i94_document" style={{ cursor: 'pointer' }}>Upload</label>
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="text"
                                                                        value={fileNames.i94_document || ''}
                                                                        readOnly
                                                                        placeholder="No file chosen"
                                                                    />
                                                                </div>
                                                                {errors.i94_document && <p style={{color:"Red" , width:"100%"}}>{errors.i94_document}</p>}
                                                            </Grid>:
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container alignItems="flex-end" flexDirection="column">
                                                                <span>Upload the latest passport of the Jobseeker<small>*</small></span>
                                                                <div className="fileUploadInput">
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="file"
                                                                        name="passport_document"
                                                                        id="passport_document"
                                                                        onChange={handleFileChange}
                                                                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                                                                        style={{ display: 'none' }} // Hide the actual file input
                                                                    />
                                                                    <label htmlFor="passport_document" style={{ cursor: 'pointer' }}>Upload</label>
                                                                    <input
                                                                        disabled={!showSubmits}
                                                                        type="text"
                                                                        value={fileNames.passport_document || ''}
                                                                        readOnly
                                                                        placeholder="No file chosen"
                                                                    />
                                                                </div>
                                                                {errors.passport_document && <p style={{color:"Red" , width:"100%"}}>{errors.passport_document}</p>}
                                                            </Grid>}
                                                            </>}
                                                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                                            {showSubmits && 
                                                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-md-5 gap-3">
                                                                <button className='registersendbtn2' disabled={submitloader} onClick={(e) => handleSubmit(e, true)}>{submitloader2 ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Complete'}</button>
                                                                <button type='submit' className='registersendbtn1' disabled={submitloader} onClick={(e) => handleSubmit(e, false)}>{submitloader ? <img src={require('../../../../assets/pinkloader.gif')} alt=''/> : 'Save'}</button>
                                                                {editMode && 
                                                                    <button className='registersendbtn1' disabled={submitloader} onClick={()=> setEditMode(false)}>Cancel</button>
                                                                }
                                                            </Grid>
                                                            }
                                                        </Grid>
                                                    </form>
                                                    </> :

                                                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="i94viewvalidate">
                                                        {!opendata2 &&
                                                        <Grid size={{sm:12}} container className="my-3" flexDirection="column">
                                                            <span>Did Jobseeker Submit a valid I94 document in the application ?<small>*</small> <a className='view_fileshows' href={`${i94copy}`} target="_blank" rel="noopener noreferrer">View</a></span>
                                                            <p>{formData.valid_i94_doc}</p>
                                                        </Grid>}
                                                        {opendata && <>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Passport Number of Jobseeker<small>*</small></span>
                                                            <p>{formData.passport_number}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Jobseeker type<small>*</small></span>
                                                            <p>{formData.jobseeker_type}</p>
                                                        </Grid>
                                                        
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>First name of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"}<small>*</small></span>
                                                            <p>{formData.first_name}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Last name of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"}<small>*</small></span>
                                                            <p>{formData.last_name}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Date of Birth of the Jobseeker as per {showPaaI94 ? "I-94" : "passport"}<small>*</small></span>
                                                            <p>{formData.dob}</p>
                                                        </Grid>
                                                        {!opendata2 ?
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Upload the latest I-94 of the Jobseeker<small>*</small></span>
                                                            {fileNames.i94_document ? 
                                                            <a href={`${fileNames.i94_document}`} target="_blank" rel="noopener noreferrer"><b>View</b></a>
                                                            :<p>No data</p>}
                                                        </Grid>:
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Upload the latest passport of the Jobseeker<small>*</small></span>
                                                            {fileNames.passport_document ? 
                                                            <a href={`${fileNames.passport_document}`} target="_blank" rel="noopener noreferrer"><b>View</b></a>
                                                            :<p>No data</p>}
                                                        </Grid>}
                                                        </>}
                                                        {statuserror && <p style={{color:"Red",width:"100%"}}>{statuserror}</p>}
                                                        {showedit && showSubmits &&
                                                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-md-5 gap-3">
                                                                <button className='registersendbtn1' onClick={()=> setEditMode(true)}>Edit</button>
                                                                <button className='registersendbtn2' onClick={handleslectChange} disabled={!showedit}>{submitloader2 ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Complete'}</button>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                }     
                                            </Tab>
                                            <Tab eventKey="assignment" title="Assignments">
                                                {activeTab === "assignment" && <Assignments />}
                                            </Tab>
                                            <Tab eventKey="knowledge" title="Knowledge">
                                                {activeTab === "knowledge" && <TaskKnowledge />}
                                            </Tab>
                                            <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                                {activeTab === "history" && <TaskHistory />}
                                            </Tab>
                                        </Tabs>
                                    </Grid>
                                </Grid>
                            </Tab>
                            {showCase && 
                            <Tab eventKey="case" title="Case">
                                {activeTabCase === "case" && <CaseDetails expanded={expanded}/>}
                            </Tab>
                            }
                        </Tabs>
                    </Grid>
                    <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 5 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                        <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                            {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                        </button>
                        <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                            <OnboardingDiscussTab showCase={showCase} />
                        </Grid>
                    </Grid>
                </Grid>}</>:
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    <Grid size={{sm:12}} container alignItems="center">
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead border_botomer mario_fixers">
                            <h3>I94 Validation <small className='small_headingstatuses'>{status&&<>{status === "completed" ? "Completed":status === "rejected"? "Rejected":"In Progress"}</>}</small></h3>
                            {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) ? 
                                <Link className='seekerondetail' to={`/user/jobseeker-details/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>:
                                <Link className='seekerondetail' to={`/user/jobseeker-profile/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>
                            }
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="center" className="my-5">
                            <Grid size={{md:6,xs:12}} container flexDirection="column" alignItems="center" className="onboard_jobseekerbox">
                                <img src={require("../../../../assets/sample/shield.svg").default} alt=''/>
                                <span>You are restricted from viewing the task due to security reasons. If you have any questions regarding the task, please contact your recruiter.</span>
                                <button style={{width:"max-content"}} onClick={()=>navigate("/dashboard")} className='registersendbtn2 px-4 mb-0'>Go to Dashboard</button>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
            }
            <Modal
                show={show} 
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    <p>
                    Are you sure you want to change the status to{" "}
                    <strong className='uppercasers'>{selectedStatus}</strong>?
                    </p>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleClose}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={confirmStatusChange}>
                    Confirm
                </button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showCasepop} 
                onHide={handleCloseCase}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    {selectedCaseStatus === "suspend" && <small className='fw-bold'>Suspending this case will also suspend the job seeker and block future login.</small>}
                    <p>Are you sure you want to change the status to{" "}<strong className='uppercasers'>{selectedCaseStatus}</strong>?</p>
                    <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div>
                    {errorsCaseMessage && <p style={{color:"Red",width:"100%",textAlign:"left"}}>{errorsCaseMessage}</p>}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={handleCaseStatus}>
                    {loadingCase ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default I94Validation
